
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoySpecialPurposeTssStbd as ObiSimplifiedBuoySpecialPurposeTssStbdElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-special-purpose-tss-stbd.js';
 
 
 

 
 export const ObiSimplifiedBuoySpecialPurposeTssStbd = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-special-purpose-tss-stbd',
   elementClass: ObiSimplifiedBuoySpecialPurposeTssStbdElement,
   events: {
     
   }
  });
 
 